import { Instance, types } from 'mobx-state-tree';

import ProgramGroup from '@common/models/CuratorGroups/ProgramGroup';

const CuratorGroup = types.model('CuratorGroup', {
	id: types.identifierNumber,
	name: types.string,
	service_id: types.maybe(types.number),
	curator_id: types.maybe(types.number),

	program_groups: types.array(ProgramGroup),
});

export default CuratorGroup;

export interface ICuratorGroupModel extends Instance<typeof CuratorGroup> {}
